<template>
  <div class="sm-phone">
    <div class="sm-phone__top">
      <h4>Virtual Phone Number</h4>
      <div class="sm-phone__top-controls">
        <btn-block
          v-if="showPort"
          :type="'port'" 
          :text="'Port number'" 
          :icon="'icon-port'"
          @click="$router.push('port-number')"
        />
        <btn-block
          :type="'create'"
          :icon="'icon-plus'"
          :text="'Add phone'"
          @click="$router.push('phone-select')"
        />
      </div>
    </div>
    <ul 
      v-if="curPhoneList.length"
      class="sm-phone__list"
    >
      <phone-number
        v-for="phone in curPhoneList"
        :key="phone.id"
        :phone="phone"
        @hidePopups="hideItemPopups"
        @update="updatePhoneList"
      />
    </ul>
    <p
      v-else
      class="sm-empty-p"
    >You don't have a phone number set up.</p>

    <div 
      v-if="usageList.length"
      class="sm-phone__usage"
    >
      <div class="sm-phone__usage-top">
        <div>
          <h4>Phone usage</h4>
          <!-- <dropdown-block
            v-model="currentUsage.month"
            class="sm-dropdown"
            :options="monthNames"
            :searchable="false"
          >
            <template slot="placeholder">
              <span>Select month</span>
              <include-svg :name="'icon-arrow-b'" />
            </template>
            <template slot="singleLabel" slot-scope="props">
              <span>{{ props.option }}</span>
              <include-svg :name="'icon-arrow-b'" />
            </template>
          </dropdown-block> -->
        </div>
        <div>
          <div class="sm-phone__usage-top-right">
            <include-svg :name="'icon-phone'" />
            <h5>{{totalCalls}}</h5>
            <span class="sm-small">calls</span>
          </div>
          <div class="sm-phone__usage-top-right">
            <include-svg :name="'icon-clock'" />
            <h5>{{totalMinutes}}</h5>
            <span class="sm-small">minutes</span>
          </div>
        </div>
      </div>
      <table class="sm-table sm-phone__usage-table">
        <thead>
          <tr>
            <th class="sort sm-txt-upper">
              Date
              <include-svg 
                v-if="!isMobile"
                :name="'icon-arrow-b-bold'" 
              />
            </th>
            <th class="sort sm-txt-upper">
              Time
              <include-svg 
                v-if="!isMobile"
                :name="'icon-arrow-b-bold'" 
              />
            </th>
            <th class="sm-txt-upper sm-txt-right">Minutes</th>
            <th v-if="!isMobile" class="sm-txt-upper sm-txt-right">Price / Minute</th>
            <th v-else class="sm-txt-upper sm-txt-right">Price/Min</th>
            <th class="sm-txt-upper sm-txt-right">Charge</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="(item, index) in usageList" 
            :key="index"
          >
            <td>{{item.transaction_date | moment('MMMM DD, YYYY')}}</td>
            <td>{{formatTime(item.minutes)}}</td>
            <td class="sm-txt-right">{{item.minutes}}</td>
            <td class="sm-txt-right">{{formatPrice(item.price_per_minutes)}}</td>
            <td class="sm-txt-right">{{formatPrice(item.price_per_minutes * item.minutes)}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
//import Months from '@/settings/month';
//import Multiselect from 'vue-multiselect';
import { mapGetters, mapActions } from 'vuex';
import {FormatPrice} from '@/utils/general-data';
import Spinner from '@/components/Spinner';
import PhoneNumber from '@/views/customer/pages/account/components/phone-components/PhoneNumber';

export default {
  name: 'tab-phone',
  components: {
    //'dropdown-block': Multiselect,
    'sm-spinner': Spinner,
    'phone-number': PhoneNumber,
  },
  data() {
    return {
      //monthNames: Months.en,
      // TEMP
      showPort: false,
      
      tollFree: false,
      curPhoneList: [],
      usageList: [],
    //  currentUsage: {},
      showSpinner: false
    }
  },
  created() {
    this.showSpinner = true;
    Promise.all([
      this.getUserPlan(),
      this.getPhoneList(),
      this.getPhoneUsage(),
    ])
      .then(([plan, list, usage]) => {
        // Phone list
        this.curPhoneList = this.preparePhoneList(this.phoneList);

        // Phone usage
        this.usageList = usage.phone_usages;

        // User plan available features
        if (this.userPlan.has_number_porting)
          this.showPort = true;

        this.showSpinner = false;
      });
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      phoneList: 'account/phoneList',
      userPlan: 'account/userPlan'
    }),
    totalCalls() {
      return this.usageList.length
    },
    totalMinutes() {
      let minutes = 0;
      this.usageList.forEach(usage => minutes += usage.minutes);

      return this.formatTime(minutes, true);
    }
  },
  methods: {
    ...mapActions({
      getPhoneList: 'account/getPhoneList',
      getPhoneUsage: 'account/getPhoneUsage',
      getUserPlan: 'account/getUserPlan'
    }),
    formatPrice: FormatPrice,
    formatTime(minutes, showDays) {
      let hh = Math.floor(minutes / 60);
      let mm = minutes % 60;

      if (hh < 10)
        hh = `0${hh}`;

      if (mm < 10)
        mm = `0${mm}`;

      if (!showDays) {
        return `${hh}:${mm}`;
      } else {
        let dd = Math.floor(parseInt(hh) / 24);
        if (dd < 10)
          dd = `0${dd}`;

        return `${dd}:${hh}:${mm}`;
      }
    },
    updatePhoneList() {
      this.getPhoneList()
        .then(() => this.curPhoneList = this.preparePhoneList(this.phoneList));
    },
    preparePhoneList(items) {
      return items.map((_item) => {
        const temp = {..._item};
        temp.popupOpen = false;
        temp.has_phone_extension =  this.userPlan.hasOwnProperty('has_phone_extension') ? this.userPlan.has_phone_extension : true;
        temp.has_outgoing_call = this.userPlan.hasOwnProperty('has_outgoing_call') ? this.userPlan.has_outgoing_call : true;

        return temp;
      });
    },
    hideItemPopups() {
      this.curPhoneList.forEach(phone => {
        phone.popupOpen = false;
      });
    }
  }
}
</script>

<style lang="scss">
@use '@/assets/scss/general/mixins.scss' as *;
@use '@/assets/scss/framework/scss-variables.scss' as *;
@use '@/assets/scss/pages/customer/account/components/_phone.scss';
</style>
